import type { PossibleDate } from "shelving";
import { formatAgo, formatDate, formatTime, formatUntil, formatWhen, getDate, getSecondsAgo } from "shelving";

function _getTime(formatter: typeof formatWhen, possibleTarget: PossibleDate, possibleCurrent: PossibleDate = "now"): React.ReactElement {
	const target = getDate(possibleTarget);
	const current = getDate(possibleCurrent);

	const dateTime = possibleCurrent === "now" ? target.toISOString() : `PT${getSecondsAgo(target, current)}S`;
	const title = possibleCurrent === "now" ? `${formatDate(target)} ${formatTime(target)}` : `${formatDate(target)} ${formatTime(target)} to ${formatDate(current)} ${formatTime(current)}`;

	return (
		<time dateTime={dateTime} title={title}>
			{formatter(target, current)}
		</time>
	);
}

/** Show a string like `in 6d` or `3w ago` wrapped with a `<time>` element providing the machine-readable format of the same date. */
export function When({ target, current }: { target: PossibleDate; current?: PossibleDate }): React.ReactElement {
	return _getTime(formatWhen, target, current);
}

/** Show a string like `6d` or `3w` wrapped with a `<time>` element providing the machine-readable format of the same date. */
export function Ago({ target, current }: { target: PossibleDate; current?: PossibleDate }): React.ReactElement {
	return _getTime(formatAgo, target, current);
}

/** Show a string like `6d` or `3w` wrapped with a `<time>` element providing the machine-readable format of the same date. */
export function Until({ target, current }: { target: PossibleDate; current?: PossibleDate }): React.ReactElement {
	return _getTime(formatUntil, target, current);
}
